import { formatSupplement } from "../../functions/money";
import { StateLabel } from "@delibrandev/utils";
import { useEffect } from "react";

export const Attributes = ({ group, index, handleOption, itemIds, updateRequirements, tax }) => {
  const isMandatory = group.mandatory;
  const maxItems = group.maxItems;
  const groupItemsAdded = group.items.filter((item) => itemIds.includes(item.itemId)).length;

  const handleAlerts = () => {
    let mandatory = false;
    let maxItems = false;

    if (group.mandatory && groupItemsAdded === 0) {
      mandatory = true;
    }

    if (group.maxItems > 0 && (groupItemsAdded > group.maxItems || groupItemsAdded === 0)) {
      maxItems = true;
    }

    return { maxItems: maxItems, mandatory: mandatory };
  };

  const handleAttribute = (item) => {
    handleOption(item);
    const isAdd = !itemIds.includes(item.itemId);
    //Comprobaciones
    let cartError = "";
    if (isAdd) {
      if (groupItemsAdded + 1 > maxItems) cartError = "Límite de complementos superado";
    } else {
      if (groupItemsAdded - 1 > maxItems) cartError = "Límite de complementos superado";
      if (groupItemsAdded === maxItems && isMandatory) cartError = "Falta seleccionar un complemento obligatorio";
    }
    updateRequirements(cartError);
  };

  useEffect(() => {
    if (isMandatory) updateRequirements("Falta seleccionar un complemento obligatorio");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="flex-start" style={{ alignItems: "center", gap: "10px" }}>
        <h5>{group.name || `Completa tu pedido`}</h5>
        <div style={{ marginBottom: "5px" }}>
          {handleAlerts().maxItems && <StateLabel text={group.maxItems + " máximo"} state={"pending"} />}
        </div>
        <div style={{ marginBottom: "5px" }}>
          {handleAlerts().mandatory && <StateLabel text={"Obligatorio"} state={"pending"} />}
        </div>
      </div>

      <div className="details-block-list">
        <div className="row w-100">
          {group.items?.map(
            (item, i) =>
              item.name !== "" && (
                <div className="col-6" key={i}>
                  <div className="item-container">
                    <div className="item-check">
                      <input
                        id={item.itemId}
                        checked={itemIds.includes(item.itemId)}
                        type="checkbox"
                        name={`group-${index}`}
                        className="item-checkbox"
                        onChange={() => handleAttribute(item)}
                      />
                    </div>
                    <div className="item-info">
                      <label htmlFor={item.itemId}>{item.name.charAt(0).toUpperCase() + item.name.slice(1)}</label>
                      <div className="item-price">+{formatSupplement(item.price, tax)}</div>
                    </div>
                  </div>
                </div>
              ),
          )}
        </div>
      </div>
    </>
  );
};
